import { EmailTemplate } from "types/emailTemplateTypes";
import createParseMiddleware from "./createParseMiddleware";
import { parseEmailTemplateResponse } from "utils/apiParser/emailTemplateParser";

export const parseFetchEmailTemplateMiddleware = createParseMiddleware<EmailTemplate>(
    parseEmailTemplateResponse,
    'emailTemplates/fetchEmailTemplate'
)

export const parseCreateEmailTemplateMiddleware = createParseMiddleware<EmailTemplate>(
    parseEmailTemplateResponse,
    'emailTemplates/createEmailTemplate'
)

export const parseUpdateEmailTemplateMiddleware = createParseMiddleware<EmailTemplate>(
    parseEmailTemplateResponse,
    'emailTemplates/updateEmailTemplate'
)

